<!--查看答案页面 Sag 2020-04-22-->
<template>
  <div class="its-answer">
    <div class="its-header">
      <i class="its-icon its-icon-close-layer its-close fr" @click="closeDialog"></i>
    </div>
    <div class="its-container" v-html="answer.content"></div>
  </div>
</template>
<script>
export default {
  name: 'Answer',
  props: {
    answer: {
      type: Object,
      default: function () {
        return {}
      }
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  methods: {
    closeDialog: function () {
      if (this.fatherAction) {
        this.fatherAction({type: 'close'})
      }
    }
  }
}
</script>
<style scoped>
.its-answer {
  position: fixed;
  z-index: 3001;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #F7F4F8;
}
.its-header {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  /* width: calc(100% - 40px); */
  background: white;
  box-shadow: 0 5px 10px -5px rgba(134,134,134,0.3)
}
.fr {
  float: right;
}
.its-container {
  padding: 20px;
  width: 100%;
  /* width: calc(100% - 40px); */
}
.its-close {
  cursor: pointer;
}
.its-close:hover {
  color: #5591FE;
}
</style>